export const queryKeys = {
  FLAT_REALTOR_FILTER: 'FLAT_REALTOR_FILTER',
  FLAT_ID_REALTOR: 'FLAT_ID_REALTOR',
  SEARCH_KEY_SEARCH: 'SEARCH_KEY_SEARCH'
};
